/**
 * Description dot separator component.
 */
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

/**
 * Default separator.
 */
const DEFAULT_SEPARATOR = ' · ';

/**
 * Props for the DescriptionDotSeparator component.
 */
interface Props {
  children?: React.ReactNode;
}

/**
 * Styled separator.
 */
const StyledSeparator = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${30 * Screen.widthRatio}px;
  margin: 0 ${8 * Screen.widthRatio}px;
`;

/**
 * Renders the description dot separator component.
 *
 * @returns {JSX.Element} Description dot separator component
 */
export default function DescriptionDotSeparator({ children }: Props) {
  return <StyledSeparator>{children ?? DEFAULT_SEPARATOR}</StyledSeparator>;
}
